import qs from "qs"
import ApiService from "./ApiService"

class LogsApiService extends ApiService {
	static async getLogs(params = {}) {
		const query = Object.keys(params).length > 0 ? `?${qs.stringify(params)}` : ""
		const response = await fetch(`${super.getBaseUrl()}/logs${query}`, {
			headers: {
				"X-Access-Token": super.getAccessToken(),
				"Content-Type": "application/json"
			}
		})
		return await response.json()
	}
}

export default LogsApiService



// WEBPACK FOOTER //
// ./src/api/LogsApiService.js